import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { ArrowLeft, Mail, Loader2, Calendar, ExternalLink } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const MessagesPage = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    axios
      .get(`${API}/api/admin/contacts`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setMessages(r.data || []))
      .catch((e) => setError(e.response?.data?.detail || e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/admin/dashboard">
              <Button variant="outline" size="sm"><ArrowLeft size={16} className="mr-2" />Dashboard</Button>
            </Link>
            <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
              <Mail size={22} className="text-cyan-500" />
              Contact Messages
            </h1>
          </div>
          <span className="text-sm text-gray-500">{messages.length} total</span>
        </div>
      </header>

      <div className="max-w-5xl mx-auto px-6 py-8">
        {loading ? (
          <div className="flex items-center justify-center py-16 text-gray-400">
            <Loader2 className="animate-spin mr-2" size={18} /> Loading messages…
          </div>
        ) : error ? (
          <div className="bg-red-50 border border-red-100 text-red-700 rounded-xl p-4">
            <strong>Error:</strong> {error}
          </div>
        ) : messages.length === 0 ? (
          <div className="bg-white rounded-2xl border border-dashed border-gray-200 p-12 text-center">
            <Mail size={32} className="text-gray-300 mx-auto mb-3" />
            <p className="text-gray-600 font-medium">No messages yet.</p>
            <p className="text-xs text-gray-400 mt-1">Visitors who submit the contact form will appear here.</p>
          </div>
        ) : (
          <ul className="space-y-4" data-testid="messages-list">
            {messages.map((m, idx) => (
              <li key={m.id || idx} className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
                <div className="flex items-start justify-between gap-3 mb-2">
                  <div>
                    <h3 className="font-semibold text-slate-900">{m.name || 'Anonymous'}</h3>
                    <a href={`mailto:${m.email}`} className="text-sm text-cyan-600 hover:underline flex items-center gap-1">
                      {m.email} <ExternalLink size={11} />
                    </a>
                  </div>
                  <span className="text-xs text-gray-400 flex items-center gap-1 shrink-0">
                    <Calendar size={11} />
                    {m.created_at ? new Date(m.created_at).toLocaleString('en-GB') : ''}
                  </span>
                </div>
                {m.subject && (
                  <p className="text-sm font-medium text-slate-700 mb-1">Re: {m.subject}</p>
                )}
                <p className="text-sm text-gray-600 whitespace-pre-line leading-relaxed">{m.message || ''}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MessagesPage;
